// Angular Imports
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

// 3rd party imports
import { DxValidationGroupComponent } from 'devextreme-angular';

// Service imports
import { ScreenService } from '../../_services/shared-services/screen.service';
import { UserService } from '../../_services/data-services/user.service';
import { ServerErrorService } from '../../_services/shared-services/server-error.service';

// Model imports
import { AccountParameterDto } from '../../_models/account-parameter-dto';
import { UserPropertyResultDto } from '../../_models/user-property-result-dto';

// Constant imports
import { ImageConstants } from '../../_constants/image-constants';
import { ValidationFormatConstants } from '../../_constants/validation-format-constants';

// CC-Common imports
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

@Component({
  selector: 'app-add-property',
  templateUrl: './add-property.component.html',
  styleUrls: ['./add-property.component.scss'],
  standalone: false
})
export class AddPropertyComponent implements OnInit {
  @ViewChild('addPropertyValidationGroup', { static: false })
  addPropertyValidationGroup: DxValidationGroupComponent;

  loadingVisible: boolean = false;
  isSmallScreen: boolean = false;
  accountParameterDto: AccountParameterDto = new AccountParameterDto();
  helpImage: string;
  isHelpShow: boolean = false;
  accountNumberPattern: any = ValidationFormatConstants.accountNumberPattern;

  constructor(
    private screenService: ScreenService,
    private userService: UserService,
    private serverErrorService: ServerErrorService,
    private router: Router
  ) {}

  ngOnInit() {
    this.helpImage = ImageConstants.helpAccountImage;
    RxjsUtils.safeSubscribe(this.screenService.changed, () =>
      this.updateScreen()
    );

    this.updateScreen();

    RxjsUtils.subscribeToSubject(
      this.userService.getSubjectNewPropertyAdded(),
      (userProperty: UserPropertyResultDto) => {
        if (!!userProperty && !!userProperty.communityId) {
          this.userService.updateSubjectPropertySelectionChanged(userProperty);
        }
      }
    );
  }

  updateScreen(): void {
    this.isSmallScreen = this.screenService.isSmallScreen();
  }

  onHelpClick(): void {
    this.isHelpShow = true;
  }

  addProperty(event): void {
    const isValid = this.addPropertyValidationGroup.instance.validate().isValid;
    if (isValid) {
      this.loadingVisible = true;
      this.accountParameterDto.customerID =
        this.accountParameterDto.customerID.toUpperCase();
      RxjsUtils.safeSubscribe(
        this.userService.addUserProperty(this.accountParameterDto),
        (res) => {
          this.loadingVisible = false;

          if (!!res.isSuccess) {
            this.userService.updateSubjectNewPropertyAdded();
            this.router.navigate(['home']);
          }
        },
        (error) => {
          this.loadingVisible = false;
          this.serverErrorService.displayError(error);
        }
      );
    }
  }
}
